import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { findSubscription } from '../utils/subscription.utils';
import { getPage } from '../utils/page.utils';

import type { RootState } from '../types/state.types';
import { CurrentPageThunk } from 'src/redux-store/thunks/currentPage.thunks';

export const usePageTitles = (params: { subId?: string; pipeID?: string; systemID?: string }) => {
  const dispatch = useDispatch();
  const pathname = useSelector(
    (state: RootState) => state.routing.locationBeforeTransitions.pathname
  );
  const subscription = useSelector((state: RootState) =>
    findSubscription(state.subscriptions)(params.subId ?? state.subscription.id)
  );

  useEffect(() => {
    const page = getPage(pathname);

    const title = page?.getTitle({
      subscriptionName: subscription?.name,
      entityId: params.pipeID ? params.pipeID : params?.systemID,
    });

    title ? (document.title = `${title} - Sesam`) : (document.title = 'Sesam');

    if (page) {
      dispatch(
        CurrentPageThunk.set({
          id: page?.id,
          group: page?.group,
          params,
        })
      );
    }
  }, [pathname, params]);
};
